import { ProfilesService } from "../../services/profiles/service";
import { kdProfileDataFromJson } from "../../domain/kdiagram/profiles/mapper";
import { kdProfileCreateDataToJson, kdProfileDataToJson } from "../../domain/kdiagram/profiles/mapper_to_json";

const profilesService = new ProfilesService(
  localStorage.getItem("basicUrl"),
  kdProfileDataFromJson,
  kdProfileCreateDataToJson,
  kdProfileDataToJson
);
const getDefaultState = () => {
  return {
    deleteLoading: false,
    deleteError: null,
    deleteFailed: null,
  };
};

const state = getDefaultState();

const getters = {
  deleteRequestFailed: (state) => (state.deleteError !== null),
};

const actions = {
  deleteProfile: async ({ commit }, data) => {
    commit("SET_DELETE_LOADING_STATE");
    try {
      await profilesService.deleteOne(
        localStorage.getItem("quad_token"),
        data.vesselName,
        data.profileId
      );

      commit("SET_DELETE_SUCCESS_STATE");

    } catch (error) {
      commit("SET_DELETE_FAILED_STATE", error);
    }
  }
};

const mutations = {
  SET_DELETE_LOADING_STATE: (state) => {
    state.deleteLoading = true;
    state.deleteError = null;
    state.deleteFailed = null;
  },
  SET_DELETE_FAILED_STATE: (state, error) => {
    state.deleteLoading = false;
    state.deleteError = error;
    state.deleteFailed = true;
  },
  SET_DELETE_SUCCESS_STATE: (state) => {
    state.deleteLoading = false;
    state.deleteError = null;
    state.deleteFailed = false;
  },
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState());
  },
};

export const kdiagramDeleteProfileModule = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
